import { Typography } from '@mui/material';
import clsx from 'clsx';
import { createElement, isValidElement } from 'react';
import WdSvgIcon from '../../core/WdSvgIcon';

/**
 * TextWithLabel
 *
 * Componente para mostrar un texto con título e ícono opcional, en formato de bloque.
 *
 * @component
 * @param {React.ReactNode} children - Contenido principal a mostrar
 * @param {React.ReactNode|string} [icon] - Ícono a mostrar antes del título
 * @param {string} title - Título a mostrar
 * @param {string} [childrenClasses] - Clases CSS adicionales para el contenido
 * @param {string} [titleClasses] - Clases CSS adicionales para el título
 * @param {string} [className] - Clases CSS adicionales para el contenedor
 * @returns {JSX.Element}
 */
export const TextWithLabel = ({
  children,
  icon,
  title,
  childrenClasses,
  titleClasses,
  className,
  ...props
}) => {
  return (
    <div {...props} className={clsx('mb-16', className)}>
      <Typography
        className={clsx('text-slate-300 text-base font-light', titleClasses)}
        gutterBottom
      >
        {icon && typeof icon === 'string' && (
          <WdSvgIcon color="disabled" size={20}>
            {icon}
          </WdSvgIcon>
        )}
        {icon && isValidElement(icon) && createElement(icon.type, { ...icon.props })}
        <span className="mr-4">{title}</span>
      </Typography>
      <Typography className={clsx('text-slate-300 text-xl', childrenClasses)} gutterBottom>
        {children}
      </Typography>
    </div>
  );
};
